import { CreditCard, Banknote, Coffee, CupSoda, Sparkles } from "lucide-react";

export const MachineCard = ({ machine: m }) => (
  <div data-testid={`machine-card-${m.capacity}`} className="bg-slate-800 border border-slate-700 rounded-2xl p-5 sm:p-7 hover-lift">
    <div className="flex items-center gap-4 md:block">
      <span className="inline-flex items-center justify-center h-11 w-11 sm:h-12 sm:w-12 rounded-xl bg-cyan-500/15 text-cyan-400 shrink-0 md:mb-5">
        <m.icon className="h-6 w-6" />
      </span>
      <div>
        <h3 className="font-heading font-semibold text-lg leading-tight">{m.name}</h3>
        <p className="text-sm text-slate-400">Capacidad {m.capacity}</p>
      </div>
    </div>
    <div className="mt-4 md:mt-5 grid grid-cols-2 md:grid-cols-1 gap-2 md:gap-3">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-1 bg-slate-900/60 rounded-lg px-3 sm:px-4 py-2.5">
        <span className="flex items-center gap-2 text-xs sm:text-sm text-slate-300">
          <Banknote className="h-4 w-4 text-slate-400" /> Efectivo
        </span>
        <span className="font-heading font-bold text-lg md:text-base">{m.cash}</span>
      </div>
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-1 bg-cyan-500/10 border border-cyan-500/30 rounded-lg px-3 sm:px-4 py-2.5">
        <span className="flex items-center gap-2 text-xs sm:text-sm text-cyan-300">
          <CreditCard className="h-4 w-4" /> Tarjeta Cliente
        </span>
        <span className="font-heading font-bold text-lg md:text-base text-cyan-300">{m.card}</span>
      </div>
    </div>
  </div>
);

export const ClientCardBanner = () => (
  <div className="md:col-span-8 bg-gradient-to-r from-cyan-600 to-cyan-500 rounded-2xl p-6 sm:p-8" data-testid="tarjeta-cliente-banner">
    <span className="inline-flex items-center gap-2 bg-white/20 text-white text-xs font-semibold px-3 py-1 rounded-full mb-4">
      <Sparkles className="h-3.5 w-3.5" /> TARJETA VIP CLIENTE
    </span>
    <h3 className="font-heading font-bold text-xl sm:text-2xl">Ahorra en cada lavado con la Tarjeta Cliente</h3>
    <p className="mt-3 text-cyan-50 text-sm max-w-xl">
      Consíguela y recárgala directamente en el kiosco de nuestro local (opciones
      «Comprar Tarjeta» y «Cargar Saldo»). Pagarás siempre el precio reducido:
      hasta un 20% de descuento en lavadoras y secadoras.
    </p>
    <ul className="mt-5 grid grid-cols-1 sm:grid-cols-3 gap-2 sm:gap-3 text-sm text-white">
      <li className="bg-white/15 rounded-lg px-4 py-2.5 sm:py-3 flex justify-between sm:block">Lavadora 12 KG: <strong>4,00 €</strong></li>
      <li className="bg-white/15 rounded-lg px-4 py-2.5 sm:py-3 flex justify-between sm:block">Lavadora 20 KG: <strong>7,50 €</strong></li>
      <li className="bg-white/15 rounded-lg px-4 py-2.5 sm:py-3 flex justify-between sm:block">Secadora 19 KG: <strong>2,50 €</strong></li>
    </ul>
  </div>
);

export const VendingBlock = () => (
  <div className="md:col-span-4 bg-slate-800 border border-slate-700 rounded-2xl p-6 sm:p-8" data-testid="vending-block">
    <div className="flex gap-3 mb-4">
      <span className="inline-flex items-center justify-center h-11 w-11 rounded-xl bg-amber-500/15 text-amber-400">
        <Coffee className="h-5 w-5" />
      </span>
      <span className="inline-flex items-center justify-center h-11 w-11 rounded-xl bg-emerald-500/15 text-emerald-400">
        <CupSoda className="h-5 w-5" />
      </span>
    </div>
    <h3 className="font-heading font-semibold text-lg">Zona de café y snacks</h3>
    <p className="mt-2 text-sm text-slate-400">
      Mientras esperas tu colada, disfruta de nuestro rincón vending: café recién
      hecho, bebidas frías y snacks. ¡Tu espera, más agradable!
    </p>
  </div>
);
